import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { FaStamp, FaSignature } from "react-icons/fa";
import { useSelector } from "react-redux";

const SigningsOverlay = ({
  field,
  scaleFactor,
  currentDocument,
  isSigning,
  openSignModal,
}) => {
  const { selectedPackage } = useSelector((state) => state.userPackages);

  const [signerName, setSignerName] = useState("");

  const normalizeName = (name) => {
    const parts = name?.split("_");
    return parts.length >= 3 ? parts.slice(0, 2).join("_") : name;
  };

  const labelMap = {
    notary_seal_a: "Notary Seal 1",
    notary_sign_a: "Notary Signature 1",
    notary_seal_b: "Notary Seal 2",
    notary_sign_b: "Notary Signature 2",
    sign_a: "Signer 1",
    sign_b: "Signer 2",
    sign_c: "Signer 3",
  };

  const signerKeyMap = {
    sign_a: "signer_1",
    sign_b: "signer_2",
    sign_c: "signer_3",
  };

  useEffect(() => {
    if (!field?.name) return;

    const normalized = normalizeName(field.name);
    const mappedKey = signerKeyMap[normalized];
    const signer = selectedPackage?.signers?.[mappedKey];

    if (signer?.first_name || signer?.last_name) {
      const name = `${signer.first_name || ""} ${
        signer.last_name || ""
      }`.trim();
      setSignerName(name);
    } else {
      setSignerName("");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPackage?.signers, field?.name]);

  const handleOverlayClick = (e) => {
    if (isSigning) openSignModal(e, field);
  };

  const bgColor = (() => {
    const name = field?.name || "";
    if (name.startsWith("notary_seal_a") || name.startsWith("notary_sign_a"))
      return "RGBA(75, 85, 175, 0.6)";
    if (name.startsWith("notary_seal_b") || name.startsWith("notary_sign_b"))
      return "rgba(65, 110, 180, 0.6)";
    if (name.startsWith("sign_a")) return "RGBA(60, 145, 80, 0.6)";
    if (name.startsWith("sign_b")) return "RGBA(175, 60, 60, 0.6)";
    return "RGBA(140, 80, 180, 0.6)";
  })();

  return (
    <Box
      onClick={handleOverlayClick}
      sx={{
        position: "absolute",
        left: `${field.x * scaleFactor}px`,
        top: `${
          (currentDocument.actualHeight - field.y - field.height) * scaleFactor
        }px`,
        width: `${field.width * scaleFactor + 4}px`,
        height: `${field.height * scaleFactor + 2}px`,
        background: bgColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        color: "white",
        fontSize: "14px",
        fontWeight: "bold",
        textAlign: "center",
        textTransform: "uppercase",
        boxShadow: "0px 0px 5px RGBA(0, 0, 0, 0.2)",
        transition: "opacity 0.3s ease-in-out",
        "&:hover": {
          opacity: 0.8,
        },
        cursor: isSigning ? "pointer" : "default",
        zIndex: isSigning ? 99999 : undefined,
      }}
    >
      {["notary_seal_a", "notary_seal_b"].includes(
        normalizeName(field.name)
      ) ? (
        <>
          <FaStamp size={16} color="white" />
          <Typography fontWeight="bold" mt={0.3} variant="caption">
            {labelMap[normalizeName(field.name)]}
          </Typography>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Typography fontWeight="bold" variant="caption">
            {labelMap[normalizeName(field.name)]}
          </Typography>
          <FaSignature size={18} color="white" />
        </Box>
      )}

      {signerName && (
        <Typography
          sx={{
            position: "absolute",
            bottom: 4,
            right: 8,
            fontSize: "12px",
            fontWeight: "bold",
            color: "white",
            textAlign: "right",
            fontFamily: "'Caveat', cursive",
          }}
        >
          {signerName}
        </Typography>
      )}
    </Box>
  );
};

export default SigningsOverlay;
